module.exports = __webpack_public_path__ + "img/favicon-bouygues.31d29d05.png";